import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApplicantDetails, updateApplicantHiredStatus } from '../../store/slices/applicantDetailsSlice';
import { Box, Avatar, Text, Flex, Divider, Button, IconButton, Spinner, Alert, AlertIcon } from '@chakra-ui/react';
import { CheckIcon, ArrowBackIcon } from '@chakra-ui/icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useJobListRefreshContext } from '../../utils/context/JobListRefresh';

const ApplicantProfile = ({ userId, onBack, jobId }) => {
  const dispatch = useDispatch();
  const { applicantDetails, loading, error, isHired } = useSelector((state) => state.applicantDetails);
  const { triggerJobListRefresh } = useJobListRefreshContext();
  // const [isHired, setIsHired] = useState(false);
  // const [isHired, setIsHired] = useState(applicantDetails.isHired || false);

 
  
  useEffect(() => {
    if (userId && jobId) {
      // console.log("Job ID:", jobId, "User ID:", userId);
      dispatch(fetchApplicantDetails({ userId, jobId }));
    }
  }, [userId,jobId, dispatch]);
  useEffect(() => {
    console.log("Render: isHired:", isHired);
  }, [isHired]);
  
  const handleApprove = async () => {
    if (isHired) return;
    // console.log("Job ID:", jobId, "User ID:", userId); // Check values here
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/provider/hire-applicant`,
        { jobId, userId,emailAddresses: [email] }, // Send jobId and userId in the request body
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
     

      if (response.status === 200) {
        if (response.data.status === "Assigned") {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: response.data.message,
            confirmButtonColor: '#d33',
            width: '300px', // Make the box smaller
            timer: 4000, // Close automatically after 10 seconds (10000 ms)
            timerProgressBar: true,
          });
        }else if(response.data.status === "error"){
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: response.data.message,
            confirmButtonColor: '#d33',
            width: '300px', // Make the box smaller
            timer: 4000, // Close automatically after 10 seconds (10000 ms)
            timerProgressBar: true,
          });
        }
        else {
          console.log("Applicant successfully hired!");
          Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Applicant successfully hired!',
          confirmButtonColor: '#3b82f6',
          width: '300px', // Make the box smaller
          timer: 4000, // Close automatically after 10 seconds (10000 ms)
          timerProgressBar: true, // Show a progress bar
        }); 
        // setIsHired(true);
        console.log("Before update:", isHired);
        dispatch(updateApplicantHiredStatus(true)); // Update global state
        // console.log("Re-fetching applicant details after hiring. Job ID:", jobId, "User ID:", userId);
          dispatch(fetchApplicantDetails({userId,jobId}));
          triggerJobListRefresh();
        }
      }

    } catch (error) {
      console.error('Error hiring applicant:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to hire the applicant.',
        confirmButtonColor: '#d33',
        timer: 4000, // Close automatically after 10 seconds (10000 ms)
        timerProgressBar: true,
      });
    }
  };

  if (!userId) return null;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    const errorMessage = typeof error === 'string' ? error : error.message || 'An error occurred';
    return (
      <Box mt={10}>
        <Alert status="error">
          <AlertIcon />
          {errorMessage || 'An error occurred'}
        </Alert>
      </Box>
    );
  }

  if (!applicantDetails) return null;

  const {
    FullName = 'John Doe',
    registerNumber = '#1234',
    email = 'johndoe@gmail.com',
    contact_no = '+4189078943',
    address = {},
    profile_image_url = 'https://image.tmdb.org/t/p/original/rbkdtSKfRrsT5kxN9F2P7lAxNPc.jpg',
    bio = 'Experienced professional...',
    experience = 'N/A',
    skills = [],
    agencyDetails = {},
  } = applicantDetails;

  const formattedLocation = `${address.contact_address || 'N/A'}`;

  return (
    <Box
      p={6}
      bg="gray.50"
      minHheight="100vh"
      display="flex"
      flexDirection="column"
      position="relative"
    >
      {/* Back Button */}
      <IconButton
        icon={<ArrowBackIcon />}
        position="absolute"
        size="sm"
        top="10px"
        left="10px"
        color="blue"
        bg="transparent"
        _hover={{ bg: 'transparent' }}
        onClick={onBack}
      />

      <Box fontWeight="semibold" fontSize="lg" color="gray.500">
        <Text as="span" color="black">Applicant Information</Text>
      </Box>
      <Flex mt={6} gap={8} direction={{ base: 'column', md: 'row' }} height="auto">
        {/* Left Profile Section */}
        <Box
          bg="white"
          p={6}
          rounded="md"
          shadow="sm"
          width={{ base: '100%', md: '320px' }}
          textAlign="center"
          height="auto"
          position={{ md: 'sticky' }}
          top={0}
        >
          <Avatar
            size="xl"
            name={FullName}
            src={profile_image_url}
            mb={4}
            boxSize="150px"
          />
          <Text fontWeight="bold" fontSize="lg">
            {FullName}
          </Text>
          {/* <Text fontSize="sm" color="gray.600">
            {skills}
          </Text> */}

          {/* Contact Details */}
          <Box mt={6} textAlign="left">
            <Text fontSize="sm" color="gray.600">
              <strong>Email: </strong>{email}
            </Text>
            <Text fontSize="sm" mt={2} color="gray.600">
              <strong>Phone: </strong>{contact_no}
            </Text>
            <Text fontSize="sm" mt={2} color="gray.600">
              <strong>Address: </strong>{formattedLocation}
            </Text>
          </Box>

          {/* Approve Button */}
          <Box mt={8}>
            <Button
              leftIcon={<CheckIcon />}
              colorScheme={isHired ? 'green' : 'blue'}
              variant="solid"
              size="lg"
              width="100%"
              height="45px"
              bg={isHired ? 'green.700' : 'blue.500'}
              color="white"
              borderRadius="0.5rem"
              _hover={{
                bg: isHired ? 'green.600' : 'blue.600',
                transition: 'background-color 0.3s ease',
              }}
              onClick={handleApprove}
              isDisabled={isHired}
            >
              {isHired ? 'Hired' : 'Approve'}
            </Button>
          </Box>
        </Box>

        {/* Right Info Section */}
        <Box
          flex="1"
          bg="white"
          p={6}
          rounded="md"
          shadow="sm"
          overflowY="auto"
          height="550px"
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            '&': {
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
            }
          }}
        >
          {/* Personal Details */}
          <Box mb={6}>
            <Text fontWeight="bold" fontSize="md" mb={4}>
              Personal Details
            </Text>
            <Divider />
            <Flex justify="space-between" mt={4}>
              <Text color="gray.600">Register Number</Text>
              <Text fontWeight="semibold">{registerNumber}</Text>
            </Flex>
            <Flex justify="space-between" mt={2}>
              <Text color="gray.600">Full Name</Text>
              <Text fontWeight="semibold">{FullName}</Text>
            </Flex>
            <Flex justify="space-between" mt={2}>
              <Text color="gray.600">Country</Text>
              <Text fontWeight="semibold">{address.country?.name || 'N/A'}</Text>
            </Flex>
            <Flex justify="space-between" mt={2}>
              <Text color="gray.600">Postal Code</Text>
              <Text fontWeight="semibold">{address.pinCode?.postalCode || 'N/A'}</Text>
            </Flex>
            <Flex justify="space-between" mt={2}>
              <Text color="gray.600">Region</Text>
              <Text fontWeight="semibold">{address.pinCode?.region || 'N/A'}</Text>
            </Flex>
          </Box>

          {/* Additional Details */}
          <Box mb={6}>
            <Text fontWeight="bold" fontSize="md" mb={4}>
              Additional Details
            </Text>
            <Divider />
            <Text textAlign="left" color="gray.600" mb={2}>Bio</Text>
            <Text color="gray.400" textAlign="left">
              {bio}
            </Text>
            <Text textAlign="left" color="gray.600" mt={4}>Experience</Text>
            <Text color="gray.400" textAlign="left">
              {experience}
            </Text>
          </Box>

          {/* Professional Details */}
          <Box>
            <Text fontWeight="bold" fontSize="md" mb={4}>
              Professional Details
            </Text>
            <Divider />
            <Flex justify="space-between" mt={4}>
              <Text color="gray.600">Specializations</Text>
              <Flex wrap="wrap" gap={2}>
                {skills.length > 0 ? (
                  skills.map((skill, index) => (
                    <Box
                      key={index}
                      bg="gray.100"
                      color="blue.800"
                      px={3}
                      py={1}
                      borderRadius="md"
                      fontWeight="semibold"
                    >
                      {skill}
                    </Box>
                  ))
                ) : (
                  <Text color="gray.800" fontWeight="semibold">N/A</Text>
                )}
              </Flex>
            </Flex>
            {/* <Flex justify="space-between" mt={4}>
              <Text color="gray.600">License ID</Text>
              <Text color="gray.800" fontWeight="semibold">{agencyDetails.licenseId || 'N/A'}</Text>
            </Flex>
            <Flex justify="space-between" mt={4}>
              <Text color="gray.600">Certification</Text>
              <Text color="gray.800" fontWeight="semibold">{agencyDetails.certification || 'N/A'}</Text>
            </Flex>
            <Flex justify="space-between" mt={4}>
              <Text color="gray.600">Issuing Authority</Text>
              <Text color="gray.800" fontWeight="semibold">{agencyDetails.issuingAuthority || 'N/A'}</Text>
            </Flex> */}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ApplicantProfile;
